import { GameServices } from '../services/game-services';
import { BlocksMainScene } from '../scenes/blocks-main-scene';
import { BoardViewModel } from '../interface/board/board-view-model';
import { BoardView } from '../interface/board/board-view';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';

export class GameController {
  private readonly gameServices: GameServices;
  private readonly boardViewModel: BoardViewModel;
  private boardView?: BoardView;

  constructor(gameServices: GameServices) {
    this.gameServices = gameServices;
    this.boardViewModel = new BoardViewModel(gameServices);
  }

  public initGraphics(scene: BlocksMainScene) {
    this.boardView = new BoardView(scene, 0, 0, this.boardViewModel);
    this.onResize(scene.currentGameSizeMetrics);
  }

  public onResize(gameSizeMetrics: GameSizeMetrics) {
    this.boardView?.onResize(gameSizeMetrics);
  }

  public onSceneReady() {
    this.gameServices.gameListenerService.onGameLoaded();

    if (this.gameServices.usingLocalDealer) {
      this.gameServices.gameRunnerService.createLocalGame();
    }
  }

  public showStartButton(showButton: boolean): void {
    this.boardViewModel.showStartButton(showButton);
  }

  public startRemoteRound(moves: string[]): void {
    if (moves.length > 0) {
      this.gameServices.gameRunnerService.startExistingRemoteRound(moves);
      return;
    }
    this.gameServices.gameRunnerService.startNewRemoteRound();
  }

  public setInstantFinish(): void {
    this.gameServices.gameRunnerService.setInstantFinish();
  }

  public autoStartGame(): void {
    this.gameServices.gameListenerService.onStartGame();
  }

  public resetGameScene(): void {
    this.boardViewModel.resetGameScene();
  }
}
